import { useStoreContext } from 'features/store';

export const useEnableUnifiedMenu = () => {
  const { store } = useStoreContext();
  const isUnifiedMenuEnabled = !!store.isOneMenu;
  return Boolean(isUnifiedMenuEnabled);
};
